import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  section6Validation,
} from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";

import {
  getSection6DataSingleId,
  updateSection6Data,
} from "../../../redux/cms/action";


const Section6Update = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const section6Data = useSelector(
    (state) => state?.reusableSlice?.getSection6single
  );


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: section6Data?.title || "",
      ar_title: section6Data?.ar_title || "",
      sub_title: section6Data?.sub_title || "",
      ar_sub_title: section6Data?.ar_sub_title || "",
    },
    validationSchema: section6Validation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    try {
      const data = {
        ...values,
        status: 1,
        id: section6Data?.id,
        section: section6Data?.section,
      };
      dispatch(updateSection6Data(data, setLoading, navigate));
    } catch (error) {
      console.error("Submit Error:", error);
    }
  };


  useEffect(() => {
    if (id) {
      dispatch(getSection6DataSingleId(id));
    }
  }, [id]);

  return (
    <div className="px-3">

      <div className=" category-wrapper">
        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-between align-items-center pb-5">
            <h3>Section - 8 </h3>

          </div>
          <div className="box-shadowsec">
            <div className="row ">

              <div className="col-md-12 form-group">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter title"
                  name="title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.title}
                />
                {formik.touched.title && formik.errors.title ? (
                  <div className="error">{formik.errors.title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Sub Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter sub title"
                  name="sub_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.sub_title}
                />
                {formik.touched.sub_title && formik.errors.sub_title ? (
                  <div className="error">{formik.errors.sub_title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Ar title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter ar title"
                  name="ar_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ar_title}
                />
                {formik.touched.ar_title && formik.errors.ar_title ? (
                  <div className="error">{formik.errors.ar_title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Ar Sub Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter ar sub title"
                  name="ar_sub_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ar_sub_title}
                />
                {formik.touched.ar_sub_title && formik.errors.ar_sub_title ? (
                  <div className="error">{formik.errors.ar_sub_title}</div>
                ) : null}
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center    "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Update" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Section6Update;
